<template>
	<div id="app"><router-view /></div>
</template>
<script>
import { host } from '@/utils/config.js';
export default {
	watch: {
		$route() {
			// console.log(to, from)
			// this.wechat()
		}
	},
	created() {
		document.title="福建省民族管弦乐学会"
		this.getConfig()
		this.setWechat()
		this.getResource()
	},
	methods: {
		getConfig() {
			this.$get('api/common/getConfig').then(res => {
				this.$store.commit('setCommonConfig', res.data)
			})
		},
		wechat() {
			// this.$get('/api/index/getActivitySetting')
			const activity_id = this.$route.query.activity_id;
			this.$get('/api/index/getActivitySetting', { activity_id }).then(res => {
				this.$store.commit('setActivitySetting', res.data);
				document.title = res.data.title;
			});
			//console.log('activity_id', activity_id)
			let tempUrl = window.location.href;
			// console.log('tempUrl1222211',tempUrl)
			if (tempUrl.indexOf('from') > -1) {
				// 二次分享会自动拼接&form=来源，需要切割掉
				tempUrl = tempUrl.indexOf('?from') > -1 ? tempUrl.split('?from')[0] : tempUrl.split('&from')[0];
				// location.href= tempUrl+"#hashchat"; // 如果子页面需要分享,就用这个
				window.location.href = tempUrl + '#/?activity_id=' + activity_id; // 只有一个页面分享，就不用带参数
				// console.log('tempUrl112', tempUrl, window.location.href)
			}
			// console.log({url, activity_id})
			const url = window.location.href.split('#')[0];
			this.$get('wechat/share', { url, activity_id }).then(res => {
				// localStorage.setItem('SHARE', res.data)
				this.$store.commit('setShareConfig', res.data.share);
				this.$wx.config(res.data.jssdk);
				this.shareInfo = res.data.share;
			});
			this.$wx.ready(() => {
				const shareInfo = this.shareInfo;
				const activity_id = this.$route.query.activity_id;
				const user_id = localStorage.getItem('user_id');
				let link = `${host}/dist/#/?activity_id=${activity_id}`;
				// console.log('activity_id', activity_id)
				// console.log('shareInfo', shareInfo)
				// console.log('user_id', user_id)
				if (user_id) {
					link = `${host}/dist/#/?activity_id=${activity_id}&inviter_id=${user_id}`;
				}
				// console.log('link', link)
				this.$wx.updateAppMessageShareData({
					title: shareInfo.title, // 分享标题
					desc: shareInfo.desc, // 分享描述
					link,
					imgUrl: shareInfo.img, // 分享图标
					success: () => {
						// console.log(link)
						// this.$get('/api/index/shareCallback')
					}
				});
				this.$wx.updateTimelineShareData({
					title: shareInfo.title, // 分享标题
					link,
					imgUrl: shareInfo.img, // 分享图标
					success: () => {
						// console.log(link)
						// this.$get('/api/index/shareCallback')
					}
				});
			});
		},
		setWechat() {
			let tempUrl = window.location.href
      if(tempUrl.indexOf("from") > -1){ // 二次分享会自动拼接&form=来源，需要切割掉
        tempUrl = tempUrl.indexOf("?from") > -1 ? tempUrl.split('?from')[0] :tempUrl.split('&from')[0]
        window.location.href= tempUrl + '#/?'
      }
			this.$get(`api/pay/getJssdk`, {
				share_url: encodeURIComponent(window.location.href)
			}).then(res => {
				let result = res.data
				this.$wx.config({
					debug: false,
					appId: result.appId,
					signature: result.signature,
					timestamp: result.timestamp,
					nonceStr: result.nonceStr,
					jsApiList: [
						"chooseWXPay",
						"getLocation",
						"updateAppMessageShareData",
						"updateTimelineShareData"
					]
				})
				this.$wx.ready(() => {
					// this.$wx.updateAppMessageShareData({
          //   title: '福建省民族管弦乐学会',
					// 	desc: '福建省民族管弦乐学会',
          //   link: 'http://guan.xuanyue.zaihukeji.cn/dist/#/home',
          //   imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
          // })
          // this.$wx.updateTimelineShareData({
          //   title: '福建省民族管弦乐学会',
          //   link: 'http://guan.xuanyue.zaihukeji.cn/dist/#/home',
          //   imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
          // })
					this.$wx.getLocation({
						type: 'wgs84',
						success: res => {
							console.log('success getLocation', res)
							localStorage.setItem('longitude', res.longitude)
							localStorage.setItem('latitude', res.latitude)
						},
						fail: err => {
							console.log('error getLocation',err)
						}
					})
				});
			})
		},
		getResource() {
			this.$get('api/common/getMajorIds').then(res => {
				this.$store.commit('setMajorList', res.data)
			})
		}
	},
	mounted() {}
};
</script>
<style lang="stylus">
@import 'static/style/flex.css'


*
	font-family 'Helvetica Neue', Helvetica, STHeiTi, sans-serif
	/* font-size: 14px; */
	outline none
	-webkit-tap-highlight-color transparent
	padding 0
	margin 0
	box-sizing border-box
	/* color: #333333; */
input
	border none
li
	list-style none
canvas
	width 100%
/* width 100% */
/* height 100% */
/* overflow-x hidden */
/* overflow-y scroll */
img
	width 100%
	height 100%
.no-wrap
	text-overflow ellipsis
	overflow hidden
	white-space nowrap
	word-wrap break-word
	word-break break-all
.no-wrap-2
	overflow hidden
	text-overflow ellipsis
	display -webkit-box
	-webkit-line-clamp 2
	-webkit-box-orient vertical
	word-wrap break-word
	word-break break-all
.no-wrap-3
	overflow hidden
	text-overflow ellipsis
	display -webkit-box
	-webkit-line-clamp 3
	-webkit-box-orient vertical
	word-wrap break-word
	word-break break-all
.mask
	width 100%
	height 100%
	background-color rgba(0, 0, 0, 0.6)
	position fixed
	left 0
	top 0
	z-index 99
.text-flex-center
	display flex
	justify-content center
	align-items center
	flex-direction column
.flex
	display flex
.flex-1
	flex 1
.flex-2
	flex 2
.flex-3
	flex 3
.flex-4
	flex 4
.flex-5
	flex 5
.flex-wrap
	flex-wrap wrap
.flex-nowrap
	flex-wrap nowrap
.flex-column
	flex-direction column
.flex-row-reverse
	flex-direction row-reverse
.flex-align-center
	align-items center
.flex-align-start
	align-items start
.flex-align-end
	align-items flex-end
.flex-jus-between
	justify-content space-between
.flex-jus-center
	justify-content center
.flex-jus-around
	justify-content space-around
.flex-jus-end
	justify-content flex-end
.pageTitle
	width 100%
	text-align center
	font-size 34px
	font-weight 500
	color #FFFFFF
</style>
